import { setShareModal } from '../../actions/shareCollection';
import { initialShareCollectionValue } from '../../reducers/shareCollection/utils';
import {
  fetchWebGetSharedFolderInfo,
  IWebGetSharedFolderInfoResponse200,
  IWebGetSharedFolderInfoResponse400,
} from '../../repositories/shared-folders/v1/web-get-shared-folder-info';
import { selectFolders } from '../../selectors/folders';
import { TThunkAction } from '../../types/redux';

export const getSharedFoldersInfo =
  (): TThunkAction<Promise<void[]>> =>
  (dispatch, getState, { httpApi, logger }) => {
    const folders = selectFolders(getState());

    const promisesList = folders.map(async ({ id, name }) => {
      try {
        const result = await fetchWebGetSharedFolderInfo<
          IWebGetSharedFolderInfoResponse200,
          IWebGetSharedFolderInfoResponse400
        >({
          httpApi,
          parameters: { id },
        });

        if (result.statusCode === 200) {
          const { name, hideContacts, hideComments, hideAddress, url, hideOffersLink } = result.response;

          dispatch(
            setShareModal({
              id,
              name,
              hideContacts,
              hideNotes: hideComments,
              hideAddresses: hideAddress,
              hideOffersLink,
              url,
            }),
          );
        }

        if (result.statusCode === 400) {
          dispatch(setShareModal({ id, ...initialShareCollectionValue, name }));

          logger.warning(result.response.message);
        }
      } catch (e) {
        logger.error(e, {
          description: 'Failed to get shared folder info',
        });
      }
    });

    return Promise.all(promisesList);
  };
